const statusColors = {
  created: "bg-gray-400",
  submitted: "bg-blue-500",
  manager_approved: "bg-teal-500",
  manager_rejected: "bg-red-400",
  approved: "bg-green-500",
  rejected: "bg-red-500",
  processing: "bg-indigo-500",
  partially_fulfilled: "bg-indigo-500",
  fulfilled: "bg-emerald-500",
  cancelled: "bg-gray-400",
};

const RequisitionTimeline = ({ auditTrail = [] }) => {
  if (!auditTrail || auditTrail.length === 0) {
    return (
      <p className="text-gray-400 text-sm italic">No activity recorded yet.</p>
    );
  }

  return (
    <div className="relative">
      {auditTrail.map((entry, index) => {
        const isLast = index === auditTrail.length - 1;
        const circleColor = statusColors[entry.action] || "bg-gray-400";

        return (
          <div key={index} className="flex items-start mb-0">
            {/* Timeline line + circle */}
            <div className="flex flex-col items-center mr-4">
              <div
                className={`w-3 h-3 rounded-full ${circleColor} ${
                  isLast ? "ring-4 ring-blue-100" : ""
                }`}
              />
              {!isLast && (
                <div className="w-0.5 h-12 bg-gray-300" />
              )}
            </div>

            {/* Content */}
            <div className="pb-6 -mt-0.5">
              <p className="text-sm font-semibold capitalize text-gray-800">
                {entry.action.replace(/_/g, " ")}
              </p>
              <p className="text-xs text-gray-500">
                {entry.performedBy?.name || "System"} &middot;{" "}
                {new Date(entry.timestamp).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </p>
              {entry.comment && (
                <p className="text-xs text-gray-600 mt-1 italic">
                  "{entry.comment}"
                </p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RequisitionTimeline;
